<template>
    <b-container>
        <b-alert show variant="primary" class="text-center">
            <i class="fa fa-info-circle fa-2x fa-fw mr-2"></i>
            Elija una de las opciones disponibles de analítica
        </b-alert>

        <b-row>
            <b-col class="mt-4 mb-2">
                <span>Guías</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <div class="border bg-white mb-3 mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'analytics-breakdown-day' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Analytics', 'analytics-breakdown-day')"
                    >Analítica desglosada de guías por día</a>
                </div>
            </b-col>
            <b-col cols="4">
                <div class="border bg-white mb-3 mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'analytics-grouped' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Analytics', 'analytics-grouped')"
                    >Analítica de guías agrupada</a>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="mt-4 mb-2">
                <span>Compañías de buses</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <div class="border bg-white mb-3 mb-3">
                    <a
                        class="p-5 text-center font-weight-bold"
                        :class="this.activeOption == 'analytics-bus-companies-breakdown-day' ? 'nav-link active disabled' : 'nav-link'"
                        @click.prevent="navigate('Analytics', 'analytics-bus-companies-breakdown-day')"
                    >Analítica desglosada de compañías de buses por día</a>
                </div>
            </b-col>
        </b-row>
        
    </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    methods: {
        async navigate(tab, option) {
            await this.$store.dispatch("layout/setActiveTabAndOption", {tab: tab, option: option})
        }
    },
    computed: {
      ...mapGetters(['activeTab', 'activeOption'])
    }
}
</script>